<template>
  <div class="app-container">
    <Sidebar v-if="authStore.token && authStore.selectedCompany" />
    <main class="main-content">
      <RouterView />
    </main>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import Sidebar from "@/components/layout/Sidebar.vue";

export default {
  components: { Sidebar },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
};
</script>
<style>
.app-container {
  display: flex;
  width: 100%;
}

.main-content {
  flex-grow: 1;
  padding: 20px;
}
</style>
